import React from 'react'

const RejectIcon = ({width, height}) => {
  return (
    <svg
      width={width || "40"}
      height={height || "40"}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.25"
        width="39.5"
        height="39.5"
        rx="7.75"
        fill="#FFEBEB"
        stroke="#E50509"
        stroke-width="0.5"
      />
      <circle cx="19.6719" cy="20" r="12" fill="#E50509" />
      <path
        d="M26.0401 13.3198C26.3132 13.5835 26.3431 14.0044 26.1245 14.3023L26.0588 14.3803L21.0233 19.5964L26.2407 24.6349C26.5387 24.9226 26.547 25.3974 26.2593 25.6954C25.9955 25.9685 25.5745 25.9982 25.2767 25.7797L25.1988 25.7139L19.9813 20.6755L14.9471 25.8914C14.6594 26.1894 14.1846 26.1979 13.8866 25.9102C13.6135 25.6464 13.5836 25.2255 13.8021 24.9277L13.8679 24.8496L18.9023 19.6335L13.6878 14.5979C13.3898 14.3101 13.3816 13.8353 13.6693 13.5374C13.9331 13.2643 14.354 13.2345 14.6519 13.4531L14.7298 13.5189L19.9443 18.5545L24.9796 13.3385C25.2673 13.0405 25.7421 13.032 26.0401 13.3198Z"
        fill="white"
      />
    </svg>
  );
}

export default RejectIcon